import AtriumApi from "api";
import LineChart from "components/charts/LineChart";
import Loader from "components/loader/Loader";
import { useEffect, useState } from "react";

const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: false,
    },
  },
  markers: {
    size: 0,
    colors: "white",
    strokeColors: "#7551FF",
    strokeWidth: 3,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    // discrete: [],
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: {
    theme: "dark",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    type: "line",
    // width: [3, 3],
    width: 4,
    dashArray: [0, 0],
  },
  xaxis: {
    type: "category",
    categories: [
      "12AM",
      "1AM",
      "2AM",
      "3AM",
      "4AM",
      "5AM",
      "6AM",
      "7AM",
      "8AM",
      "9AM",
      "10AM",
      "11AM",
      "12PM",
      "1PM",
      "2PM",
      "3PM",
      "4PM",
      "5PM",
      "6PM",
      "7PM",
      "8PM",
      "9PM",
      "10PM",
      "11PM",
    ],
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    type: "numeric",
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
        fontWeight: "500",
      },
    },
  },
  legend: {
    show: true,
    horizontalAlign: "left",
    markers: {
      offsetX: -5,
      strokeWidth: 0,
      size: 5,
    },
    labels: {
      colors: ["#A3AED0", "#A3AED0"],
    },
    itemMargin: {
      horizontal: 15,
    },
  },
  grid: {
    show: false,
  },
};

// select the current day by default in initial state
const getToday = () => {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const todayIndex = new Date().getDay(); // 0 = Sun, 1 = Mon, ..., 6 = Sat
  return days[todayIndex];
};

function AttendancePeak({ selectedCampusId }) {
  const [filter, setFilter] = useState(getToday());
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const newOptions = {
    ...chartOptions,
    // colors: ["#A7D5BA", "#EF9C8F"],
    colors: ["#EF9C8F"],
  };

  useEffect(() => {
    function buildQueryString() {
      let query = `day=${filter}`;
      if (selectedCampusId && selectedCampusId !== "all") {
        query += `&campusId=${selectedCampusId}`;
      }
      return query;
    }
    const fetchAttendanceHour = async () => {
      try {
        setLoading(true);
        const query = buildQueryString();
        const response = await AtriumApi.get(`/v1/peakhours?${query}`);
        if (response) {
          setLoading(false);
          setChartData(response?.data?.data);
        }
      } catch (error) {
        setLoading(false);
        console.log("fetching attendance hour error", error);
      }
    };
    fetchAttendanceHour();
  }, [filter, selectedCampusId]);

  return (
    <>
      <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
        {loading ? (
          <div className="flex items-center justify-center h-full w-full">
            <Loader />
          </div>
        ) : (
          <>
            {/* header */}
            <div className="flex">
              <div className="flex-1">
                <p className="text-gray-700">Attendance Peak Hour</p>
                <p>
                  <span className="text-2xl font-bold mr-2">
                    {new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </p>
              </div>
              <div>
                <select
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  className="bg-[transparent] h-12 text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4"
                >
                  <option value="Sun">Sunday</option>
                  <option value="Mon">Monday</option>
                  <option value="Tue">Tuesday</option>
                  <option value="Wed">Wednesday</option>
                  <option value="Thu">Thursday</option>
                  <option value="Fri">Friday</option>
                  <option value="Sat">Saturday</option>
                </select>
              </div>
            </div>

            {/* chart */}
            <div className="block h-[300px]">
              <div className="h-full w-full">
                {chartData?.length > 0 ? (
                  <LineChart chartData={chartData} chartOptions={newOptions} />
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default AttendancePeak;
